import { css } from '@repo/pandacss/css';
import { isStructuredContent } from '@/shared/ui/structured-content/StructuredContentRenderer/utils';

export const hasSCListType = (list: unknown[]): boolean =>
  list.some(
    item =>
      isStructuredContent(item) &&
      (item.type === 'List' ||
        item.type === 'Li' ||
        hasSCListType(
          Array.isArray(item.props.children) ? item.props.children : [item.props.children],
        )),
  );

export const proConsListItemBase = css.raw({
  display: 'flex',
  gap: '2',
  px: '1',
  py: '[2px]',
  alignItems: 'flex-start',
});

const proConsBulletClassBase = css.raw({
  marginTop: '[5px]',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxSize: '[14px]',
  borderRadius: 'half',
  flexShrink: 0,
  color: 'common.white',
});

export const proBulletClass = css(proConsBulletClassBase, {
  backgroundColor: 'greens.main',
});

export const conBulletClass = css(proConsBulletClassBase, {
  backgroundColor: 'reds.main',
});

const proConsBulletBeforeBase = css.raw({
  content: '""',
  marginTop: '[5px]',
  display: 'inline-block',
  boxSize: '[14px]',
  borderRadius: 'half',
  flexShrink: 0,
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
});

export const proBulletBefore = css.raw(proConsBulletBeforeBase, {
  backgroundColor: 'greens.main',
  backgroundImage: 'var(--icon-bullet-plus)',
});

export const conBulletBefore = css.raw(proConsBulletBeforeBase, {
  backgroundColor: 'reds.main',
  backgroundImage: 'var(--icon-bullet-minus)',
});
